import React from 'react';
import styled from 'styled-components';
import { appBgColor } from 'Utils/utilsStyle';
import XiqSkeletonSvg from './assets/svgIcons/XiqSkeletonSvg';

const PageShell = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${appBgColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoSkeleton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 110px;
  border-radius: 16px;

  svg {
    width: 120px;
    height: auto;
    opacity: 0.35;
    position: relative;
    z-index: 1;
  }
`;

const RouteLoader = function RouteLoader() {
  return (
    <PageShell aria-busy="true" aria-label="Loading page">
      <LogoSkeleton className="skeleton-box">
        <XiqSkeletonSvg />
      </LogoSkeleton>
    </PageShell>
  );
};

export default RouteLoader;
